// extracted by mini-css-extract-plugin
export default {"semiboldBody":"SemiboldBody-module__semiboldBody___k28pS"};